import React from 'react';
import { networkNames } from '@shared/types/executor';
import { getTxnResults } from '@shared/utils/executor/getTxnResults';
import { IoIosArrowBack } from 'react-icons/io';
import { MergedOrder } from '@/lib/db/DBOrderHistoryHelpers';
import { Button } from '@/components/ui/button';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
export default function TransactionHashes({
  txItem,
  setShowTxHashes
}: {
  txItem: MergedOrder;
  setShowTxHashes: (_: boolean) => void;
}) {
  const isMobile = useIsMobile();
  const resultState = getTxnResults(txItem?.result);
  const {
    inputSponsors,
    inputApprovals,
    inputSwaps,
    outputSwaps
  } = resultState;
  return <div className='mb-4 mt-4 flex-col gap-2 flex items-center justify-center mx-auto px-auto w-full text-sm' data-sentry-component="TransactionHashes" data-sentry-source-file="TransactionHashes.tsx">
      <p className='text-genius-cream text-sm w-full flex justify-start items-center lg:mb-12 mb-2'>
        <div onClick={() => {
        setShowTxHashes(false);
      }} className={`${!isMobile ? 'absolute top-4' : ''} cursor-pointer text-[14px] flex items-center bg-genius-blue rounded-full h-[31px] w-[74px]`}>
          <IoIosArrowBack className={`ml-1 mr-2 w-[16px] text-genius-cream`} width={20} height={18} data-sentry-element="IoIosArrowBack" data-sentry-source-file="TransactionHashes.tsx" />{' '}
          <p>Back</p>
        </div>
      </p>
      {inputSponsors?.length ? <div className='flex flex-col gap-2 w-full'>
          {inputSponsors?.map((x, idx) => {
        return <Button key={idx} variant='purple' className='w-full text-genius-cream rounded-full h-[56px]' onClick={() => {
          window.open(x?.explorerUrl?.toString(), '_blank');
        }}>
                Sponsor Transaction #{idx + 1}: {networkNames[x.network]}
              </Button>;
      })}
        </div> : <></>}
      {inputApprovals?.length ? <div className='flex flex-col gap-2 w-full'>
          {inputApprovals?.map((x, idx) => {
        const network = x?.network;
        return <Button key={idx} variant='purple' className='h-[56px] w-full text-genius-cream rounded-full' onClick={() => {
          window.open(x?.explorerUrl?.toString(), '_blank');
        }}>
                Approval Transaction #{idx + 1}: {networkNames[network]}
              </Button>;
      })}
        </div> : <></>}
      {inputSwaps?.length ? <div className='flex flex-col gap-2 w-full'>
          {inputSwaps?.map((x, idx) => {
        if (Array.isArray(x)) {
          return <div key={idx} className='flex flex-col gap-2 w-full'>
                  {x?.map((y, idy) => {
              const network = y?.network;
              return <Button key={idy} variant='purple' className='h-[56px] w-full text-genius-cream hover:text-genius-cream rounded-full h-14' onClick={() => {
                window.open(y?.explorerUrl?.toString(), '_blank');
              }}>
                        {outputSwaps?.length && 'Input '}Transaction #{idy + 1}:{' '}
                        {networkNames[network]}
                      </Button>;
            })}
                </div>;
        } else {
          const network = x?.network;
          return <Button key={idx} variant='purple' className='py-6 h-14 w-full text-genius-cream rounded-full' onClick={() => {
            window.open(x?.explorerUrl?.toString(), '_blank');
          }}>
                  {outputSwaps?.length && 'Input '}Swap Transaction #{idx + 1}:{' '}
                  {networkNames[network]}
                </Button>;
        }
      })}
        </div> : <></>}
      {outputSwaps?.length ? <div className='flex flex-col w-full'>
          {outputSwaps?.map((x, idx) => {
        const network = x?.network;
        return <Button key={idx} variant='purple' className='py-6 h-14 w-full text-genius-cream rounded-full' onClick={() => {
          window.open(x?.explorerUrl?.toString(), '_blank');
        }}>
                Output Swap Transaction #{idx + 1}: {networkNames[network]}
              </Button>;
      })}
        </div> : <></>}
    </div>;
}